import { Container, Paper, Skeleton } from "@mui/material";
import * as React from "react";
import { useTranslation } from "react-i18next";
import PaddedBox from "~/components/PaddedBox";
import { useIsMobile } from "~/utils/hooks/useIsMobile";
import { BackArrowText } from "./components/BackArrowText";
import { ProjectNavBar } from "./components/ProjectNavBar";
import { ProjectTabs } from "./components/ProjectTabs";
import { useProjectDetails } from "./hooks/useProjectDetails";
import { useProjectQuery } from "./hooks/useProjectQuery";
import { ProjectTabContent } from "./ProjectTabContent";

export type ProjectTabType = {
  activeTab: ProjectTab;
};

export type ProjectTab = typeof projectTabs[number];
const projectTabs = [
  "details",
  "map",
  "upload-progress",
  "upload-planning",
  "sub-areas",
  "wpr",
] as const;

export const ProjectPage = () => {
  const { id, activeTab } = useProjectDetails();

  const { project: projectData } = useProjectQuery({ projectId: id });
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  if (!projectData) return <Skeleton />;
  return (
    <PaddedBox>
      <Container
        maxWidth={isMobile ? false : "xl"}
        sx={{
          display: "grid",
          justifyContent: "center",
          gridTemplateColumns: isMobile ? "100%" : "90%",
          padding: isMobile ? "0px" : "16px",
          overflow: "auto",
          rowGap: "15px",
        }}
      >
        <BackArrowText url="/projects" text={t("projects:projects-list")} />
        <ProjectNavBar {...projectData} />
        <ProjectTabs />

        <Paper sx={{ p: isMobile ? "0px" : "15px", mb: "20px" }} elevation={5}>
          <ProjectTabContent {...projectData} activeTab={activeTab} />
        </Paper>
      </Container>
    </PaddedBox>
  );
};
